<!--
 * @Description: 加载动画
 * @Author: 山淑兰
 * @Date: 2020-01-06 11:44:36
 * @LastEditTime : 2020-01-14 20:13:23
 * @LastEditors  : 山淑兰
 -->
<template>
  <div id="loading">
    <div class="loading_con">
      <div class="loading-blue"></div>
      <div><img src="@assets/loading.png" alt /></div>

      <div class="loadingText">努力加载中...</div>
    </div>
  </div>
</template>
<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Loading extends Vue {}
</script>
<style lang="scss" scoped>
@keyframes fadeUp {
  0% {
    height: 0%;
  }
  100% {
    height: 97%;
  }
}
#loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(15, 23, 42, 0.6);
  z-index: 99999;
  overflow: hidden;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.loading_con {
  width: 140px;
  height: 140px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255,255,255,0.12);
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.18);
  box-shadow: 0 8px 32px rgba(0,0,0,0.3);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
#loading img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.loading-blue {
  animation: fadeUp 2s linear 1s infinite alternate;
  width: 97%;
  position: absolute;
  bottom: 1px;
  left: 1%;
  background: linear-gradient(to top, #3b82f6, #818cf8);
  border-radius: 0 0 18px 18px;
  box-shadow: 0 0 20px rgba(99,102,241,0.4);
}
.loadingText {
  position: absolute;
  bottom: -40%;
  width: 200px;
  left: -50px;
  color: rgba(255,255,255,0.9);
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 4px;
}
</style>
